import { Node } from 'tiptap';
import { Mark } from 'tiptap';
import { updateMark, toggleMark, AddMarkStep } from 'tiptap-commands';

export default class Indent extends Mark {
    get name() {
        return 'indent';
    }
    get defaultOptions(){

    }
    get schema() {
        return {
            attrs: {
                style: {
                    default: 'margin-left:24px',
                },
            },
            group: 'block',
            selectable: true,
            parseDOM: [
                {
                    tag: 'indent',
                    getAttrs: (dom) => ({
                        style: dom.getAttribute('style'),
                    }),
                },
            ],
            toDOM: (mark) => {
                return [
                    'blockquote',
                    {
                        style: mark.attrs.style,
                    },
                ];
            },
        };
    }

    // get view() {
    //     return {
    //         props: ['node', 'updateAttrs', 'view'],
    //         computed: {
    //             src: {
    //                 get() {
    //                     return this.mark.attrs.style;
    //                 },
    //                 set(style) {
    //                     style,
    //                     this.updateAttrs({
    //                         style
    //                     });
    //                 },
    //             },
    //         },
    //         render: function(createElement) {
    //           return createElement('blockquote', {attrs: {...this.node.attrs}});
    //         },
    //     }
    // }
    // type in the commands function is destructured from
    //
    commands({ type }) {
       return (attrs) => updateMark(type, attrs);
    }
}
